import { notification, message } from 'ant-design-vue';

// Configure default settings
notification.config({
    placement: 'topRight',
    duration: 4,
});

export class Notify {
    static fire(title, body, type) {
        const config = {
            message: title,
            description: body,
        };

        switch (type) {
            case 'success':
                notification.success(config);
                break;
            case 'error':
                notification.error(config);
                break;
            case 'warning':
                notification.warning(config);
                break;
            case 'info':
            default:
                notification.info(config);
                break;
        }
    }

    // Simple toast messages (smaller, less intrusive)
    static toast(text, type = 'info') {
        switch (type) {
            case 'success':
                message.success(text);
                break;
            case 'error':
                message.error(text);
                break;
            case 'warning':
                message.warning(text);
                break;
            case 'loading':
                return message.loading(text, 0); // Returns a close function
            case 'info':
            default:
                message.info(text);
                break;
        }
    }

    static emptyNotif() {
        return { title: "", message: "", type: "" }
    }
}
